import Grid from "@mui/material/Grid2";
import { Box, Divider, Typography } from "@mui/material";
import { isEmpty } from "lodash";

import { TabSessionStorageResponse } from "../../../../models/api/TabSessionStorage";
import { flexAllCentre, flexRow } from "../../../../styles/mui/styles/display";
import { documentMargin, DocumentTypeIcon } from "../../styles/style";
import { getDocTypeIcon } from "../../../../utils/DocIcons";
import { extractDocType } from "../../../../utils";
import fontWeight from "../../../../styles/mui/fontWeight";
import colors from "../../../../styles/colors/colors";
import { documentDivider } from "../../styles/Review";

export interface PropsFromState {
  tabSessionStorage: TabSessionStorageResponse;
  files: File[];
}

type AllProps = PropsFromState;

const DocumentDetails: React.FC<AllProps> = ({ files }) => {
  return (
    <Grid container pb={"2rem"} sx={flexAllCentre}>
      <Grid size={{ xs: 12 }} sx={documentMargin}>
        {files &&
          files.map((data: any, index: number) => (
            <>
              <Grid container key={data.name} sx={flexRow} pt={"0.2rem"}>
                <Grid size={{ xs: 10 }} sx={flexRow}>
                  <Box sx={DocumentTypeIcon}>
                    {getDocTypeIcon(extractDocType(data.type))}
                  </Box>
                  <Typography
                    variant="subtitle1"
                    fontWeight={fontWeight[4]}
                    color={colors.fonts[4]}
                    pt={1}
                  >
                    {data.name}
                  </Typography>
                </Grid>
              </Grid>
              {!isEmpty(files) && files.length !== index + 1 && (
                <Divider sx={documentDivider} />
              )}
            </>
          ))}
      </Grid>
    </Grid>
  );
};

export default DocumentDetails;
